const EXPORT_EXCEL_TYPE_EXPORT_RETROCESSION = 'retrocession';

export default EXPORT_EXCEL_TYPE_EXPORT_RETROCESSION;
